export enum CrmFiltersReturnMessage {
  SQL_INVALID = "Invalid SQL",
  CRM_FILTER_NOT_FOUND = "Filter is not found"
}
